export interface PricingCardProps {
  name: string
  price: string
  duration: string
  descr: string
  features: string[]
  ctaLabel: string
  ctaHref: string
}

/**
 * A `.ul-pricing-package` plan card. All three plans on `pricing.html` are
 * structurally identical — only the name, price and feature list differ — so there
 * is no "featured" variant to model.
 */
export function PricingCard({ name, price, duration, descr, features, ctaLabel, ctaHref }: PricingCardProps) {
  return (
    <div className="ul-pricing-package">
      {/* heading */}
      <div className="ul-pricing-package-heading">
        <span className="ul-pricing-package-name">{name}</span>
        <div className="ul-pricing-package-heading-bottom">
          <h3 className="ul-pricing-package-price">{price}</h3>
          <div className="right">
            <span className="ul-pricing-package-duration">
              <span className="divider">/</span>
              {duration}
            </span>
          </div>
        </div>
        <p className="ul-pricing-package-descr">{descr}</p>
      </div>

      {/* body */}
      <div className="ul-pricing-package-body">
        <ul className="ul-pricing-package-body-list">
          {features.map((feature) => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>
        <a href={ctaHref} className="ul-pricing-package-btn">
          {ctaLabel}
        </a>
      </div>
    </div>
  )
}
